(($)=>{
    "use strict";

    $('a.down.smooth-down').on('click', function(event) {
        event.preventDefault();

        const $link = $(this);
        const $target = $($link.attr('href'));
        if($target.length){
            const headerHeight = $('.site-header .header-content').height();

            const targetTop = $target.offset().top;
            const targetHeight = $target.height();

            const contentOffset = targetTop - headerHeight;

            $('html, body').stop().animate({scrollTop: contentOffset}, 500, 'swing');
        }

    });

})(jQuery)